import axios from 'axios';

const url = process.env.VUE_APP_HOST;
const home = process.env.VUE_APP_HOME;

const getEventSlot = async function (payload){

    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };

    let urlWithArg = url + 'api/Time/'+ payload.id + '/Check?from='+payload.from+'&to='+payload.to;

    let result = await axios.get(urlWithArg, headers);
    
    return result.data;

}

const postBatchBook = async function (payload){
 
    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }
    //if (!access_token) window.location = home;

    let headers = {
        headers: {
           'Authorization': `Bearer ${access_token}`
        }
    };

    let urlWithArg = url + 'api/Time/' + payload.TemplateId + '/BatchBook';

    let result = await axios.post(urlWithArg, payload, headers)
    .catch(error => {
        return error.response;
    });

    return result.data
    
}

const uploadFile = async function (payload) {
    let auth = localStorage.getItem('scientia-session-authorization');

    let access_token = "";

    if (!auth)
    {
        access_token = process.env.VUE_APP_TOKEN;
    }
    else
    {
        access_token = JSON.parse(auth).access_token;
    }

    let _url = url + 'api/Time/' + payload.identity + '/Upload'
    let headers = {
        headers: {
            'Authorization': `Bearer ${access_token}`,
           // 'Content-Type': 'multipart/form-data'
        }
    };
    let result = await axios.post(_url, payload.file, headers)

    return result.data;
}






export const eventService = { getEventSlot, postBatchBook, uploadFile }


// WEBPACK FOOTER //
// ./src/api/event.service.js